<!-- eslint-disable max-lines -->
<template>
    <div class="repayment-manage">
        <Paper class="repayment-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @elementChange="searchChange"
                        @search-change="repaymentList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.editBtn"
                        v-show="!editStatus"
                        icon="el-icon-edit"
                        type="primary"
                        size="mini"
                        title="编辑"
                        @click="editHandle">编辑
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.saveBtn"
                        v-show="editStatus"
                        icon="el-icon-edit"
                        type="primary"
                        size="mini"
                        title="保存"
                        :loading="saveLoading"
                        @click="saveHandle">保存
                    </lotsButton>
                    <lotsButton
                        v-show="editStatus"
                        icon="el-icon-canel"
                        type="primary"
                        size="mini"
                        title="取消"
                        @click="canelAction">取消
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.importBtn"
                        icon="el-icon-upload2"
                        type="primary"
                        size="mini"
                        title="导入"
                        @click="openImport">导入
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.exportBtn"
                        type="primary"
                        size="mini"
                        :loading="exportLoading"
                        title="导出">
                        <report-export
                            #default="{ submit }"
                            reportCode="REPORT_CRM_ACCOUNT">
                            <span @click="handleExport(submit)">导出</span>
                        </report-export>
                    </lotsButton>
                    <lotsButton v-show="isShowMoreBtn"  type="primary" size="mini" title="特权操作">
                        <el-dropdown class="repayment-list-dropdown" trigger="hover" :append-to-body="false">
                            <span class="el-dropdown-link">
                                特权操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="repayment-list-dropdown-menu">
                                <el-dropdown-item class="dropdown-item"
                                    @click.native="lockHandle(0)"
                                    v-has="authorityCode.unlock">解锁</el-dropdown-item>
                                <el-dropdown-item class="dropdown-item" @click.native="lockHandle(1)"
                                    v-has="authorityCode.lock">锁定</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </lotsButton>
                    <!-- <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                            icon="iconfont icon-list_install"
                            type="primary"
                            size="mini"
                            :title="'列配置'"
                            @click="showColumnConfigDialog"
                            plain />
                    </el-tooltip> -->
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        size="mini"
                        selectionWidth="50"
                        v-loading="repaymentList.tableLoading"
                        :control="false"
                        show-footer
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="repaymentList.totalData"
                        :actions="config.actions"
                        :allowRowClick="true"
                        selectionFixed="left"
                        :checkbox-config="{ labelField: 'name', highlight: true,}"
                        :sort-config="{ remote: true }"
                        :cell-config="{ height: editStatus ? 60 : 36 }"
                        :virtual-y-config="{enabled: true, gt: 0}"
                        :checkboxCellOnly="true"
                        :customEdit="true"
                        :footer-method="getSummaries"
                        :selectRows="repaymentList.selectedRows"
                        :allowRowClickFunc="allowRowClickFunc"
                        :rowClickEditFunc="rowClickEditFunc"
                        @select-click="repaymentList.handleSelectedRow"
                        @element-change="handleChangeRow"
                       >
                        <!-- <template v-slot:col-append="{item, row, rIndex}">
                             <span v-if="['lockFlag','calCustomerLevelCode','customerChannel','invoiceErrorType','rebillErrorType'].includes(item.prop)">
                                {{ codesToNames(row[item.prop],dictDatas[item.optionsKey]) }}
                            </span>
                        </template> -->
                        <template v-slot:col-append="{ item, row, rIndex }">
                            <span v-if="['invoicePlan10d','rebillPlan10d'].includes(item.prop)">
                                <el-input-number
                                    type="number"
                                    v-if="editStatus && (row.isShow10ThEdit || row.lockFlag ==='0')"
                                    :controls="false"
                                    placeholder="请输入"
                                    :key="row[item.prop + 'key']"
                                    @change="(val) => handleChangeRow({prop:item.prop, val, row, index:rIndex})"
                                    v-model="row[item.prop]">
                                </el-input-number>
                                <span v-else>
                                    {{ row[item.prop] }}
                                </span>
                            </span>
                            <span  v-if="['invoicePlan20d','rebillPlan20d'].includes(item.prop)" >
                                <el-input-number
                                    v-if="editStatus && (row.isShow20ThEdit || row.lockFlag ==='0')"
                                    type="number"
                                    :controls="false"
                                    placeholder="请输入"
                                    :key="row[item.prop + 'key']"
                                    @change="(val) => handleChangeRow({prop:item.prop, val, row, index:rIndex})"
                                    v-model="row[item.prop]">
                                </el-input-number>
                                <span v-else>
                                    {{ row[item.prop] }}
                                </span>
                            </span>
                            <span v-if="['invoiceErrorType','rebillErrorType'].includes(item.prop)">
                                <lots-select v-if="editStatus && (row.isShow20ThEdit || row.lockFlag ==='0')" :optionsKey="item.optionsKey"
                                 v-model="row[item.prop]"></lots-select>
                                <span v-else>
                                        {{ codesToNames(row[item.prop],dictDatas[item.optionsKey]) }}
                                </span>
                            </span>
                            <span v-if="['invoiceRemark','rebillRemark'].includes(item.prop)">
                                <el-input
                                    v-if="editStatus && (row.isShow20ThEdit || row.lockFlag ==='0')"
                                    type="textarea"
                                    :row="item.rows"
                                    :maxlength="500"
                                    placeholder="请输入"
                                   @change="(val) => handleChangeRow(item.prop, val, row, rIndex)"
                                    v-model="row[item.prop]">
                                </el-input>
                                <span v-else>
                                    {{ row[item.prop] }}
                                </span>
                            </span>
                            <span v-if="['lockFlag','calCustomerLevelCode','customerChannel'].includes(item.prop)">
                                {{ codesToNames(row[item.prop],dictDatas[item.optionsKey]) }}
                            </span>
                        </template>
                    </edit-table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="repaymentList.sizeChange"
                        :current-page.sync="repaymentList.pageNo"
                        @current-change="repaymentList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="repaymentList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
            <!-- 表格列配置弹框 -->
            <!-- <column-config
                :pageID="config.name"
                :initColumns="config.columns"
                ref="otpColumnConfig"
                @header-change="config.columns = $event"
            /> -->
            <!-- 导入弹窗 -->
            <addFileDialog
                ref="fileDialogRef"  @uploadSuccessHandle="uploadSuccessHandle"
                :config="config.importConfig"
            >
            <template slot="btnSlot">
                <report-export #default="{ submit }" >
                    <lotsButton type="primary" :loading="downTemplateLoading" size="mini" @click="handleDownTemplate">下载模版
                    </lotsButton>
                </report-export>
            </template>
            </addFileDialog>
        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import editTableBox from '@/modules/mdm/components/vxeTableBox/Index.vue';
// import editTableBox from '@/components/lots/editTableBox/Index';
import {
    getCustomerInvoicePage,
    getCustomerSum,
    getCustomerExprot,
    updateInvoice,
    lockInvoiceCustomer,
    invoiceTemplateDownloadApi
} from '@mdm/api/customer/repaymentPlan.js';
import {
    getIndustryTree
} from '@mdm/api/contractManage/contractRegistration.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic, isCurrentTimeAfterOrEqualMonth16th, isCurrentTimeAfterOrEqualMonth22th } from './config';
import { ref, reactive, onMounted, computed } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
import reportExport from '@/components/lots/reportExportPlugin';
// import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import Decimal from 'decimal.js';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import LotsSelect from '@/components/lots/lotsSelect/Index';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'repaymentPlan',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        editTableBox,
        lotsPagination,
        lotsButton,
        reportExport,
        addFileDialog,
        LotsSelect
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.repaymentPlan);
        const { user } = store.getters;
        const oldCondition = ref({});
        const isShowMoreBtn = computed(() => {
            const { unlock, lock } = btnAuthority.repaymentPlan;
            return (otherUtils.getHasAuth(unlock) || otherUtils.getHasAuth(lock));
        });
        class AccountListClass extends AdvanceListClass {
            constructor(options) {
                super(options);
                this.originalData = ref([]);
            }
            beforeGetList(condition) {
                const params = searchDataFormat(condition);
                oldCondition.value = _.cloneDeep(params);
                return params;
            };
            async afterGetList (res) {
                if (+res.code === 0) {
                    await getCustomerSumHandle(oldCondition.value);
                    this.totalData.value = res.data.list.map(v => {
                        // v.edit = editStatus.value ? EDIT_TYPE.EDIT : EDIT_TYPE.CANCEL;
                        v.lockFlag = v.lockFlag?.toString();
                        v.invoiceErrorType = v.invoiceErrorType?.toString();
                        v.rebillErrorType = v.rebillErrorType?.toString();
                        v.isShow10ThEdit = setTableEditHandle(v).isTenTh;
                        v.isShow20ThEdit = setTableEditHandle(v).isTwenty;
                        v.isShowEdit = setTableEditHandle(v).allStatus;
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                    // 保存原始数据副本用于校验
                    this.originalData.value = _.cloneDeep(this.totalData.value);
                }
            };
        }
        const repaymentList = new AccountListClass({
            Api: {
                listApi: getCustomerInvoicePage // 查询接口
            }
        });
        const searchDataFormat = (condition = {}, params = {}) => {
            // 新增：解析行业大类（支持多个）
            if (Array.isArray(condition.industryCategoriesCode) && condition.industryCategoriesCode.length > 0) {
            //    / 使用 _.zip 将行列转置
                const transposed = _.zip(...condition.industryCategoriesCode);
                // 获取转置后的数组并拼接成字符串
                condition.industryTypeCodeList = _.uniq(transposed[1]);
                Reflect.deleteProperty(condition, 'industryCategoriesCode');
            } else {
                Reflect.deleteProperty(condition, 'industryCategoriesCode');
            }
            if (condition.periodMonth) {
                condition.periodMonth += '-01';
            }
            Reflect.deleteProperty(condition, 'userName');
            condition.userCode = user.userCode;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return { ...condition, ...params };
        };
        const getCustomerIdList = (val) => {
            return val.map(it => it.id);
        };
        const config = reactive(configStatic);
        // 计算回款和开票相关字段的方法
        // eslint-disable-next-line complexity
        const calcRepaymentAndTicketFields = (row) => {
            try {
                // 获取相关字段值，使用Decimal确保精度
                const invoicePlan20d = row.invoicePlan20d ? new Decimal(row.invoicePlan20d) : new Decimal(0); // 开票预计完成20日
                const invoicePlan10d = row.invoicePlan10d ? new Decimal(row.invoicePlan10d) : new Decimal(0); // 开票预计完成10日
                const invoiceFinishAmount = row.invoiceFinishAmount ? new Decimal(row.invoiceFinishAmount) : new Decimal(0); // 开票完成
                const invoicePlanAmount = row.invoicePlanAmount ? new Decimal(row.invoicePlanAmount) : new Decimal(0); // 开票计划
                const rebillPlan20d = row.rebillPlan20d ? new Decimal(row.rebillPlan20d) : new Decimal(0); // 回款预计完成20日
                const rebillPlan10d = row.rebillPlan10d ? new Decimal(row.rebillPlan10d) : new Decimal(0); // 回款预计完成10日
                const rebillFinishAmount = row.rebillFinishAmount ? new Decimal(row.rebillFinishAmount) : new Decimal(0); // 回款完成
                const rebillPlanAmount = row.rebillPlanAmount ? new Decimal(row.rebillPlanAmount) : new Decimal(0); // 回款计划

                // 1. invoiceInTransitGap开票在途缺口（万元）
                //   开票预计完成20日不为空，等于 开票预计完成20日 -  开票完成
                // 否则等于 开票预计完成10日 -  开票完成
                // debugger;
                if (!invoicePlan20d.isZero()) {
                    row.invoiceInTransitGap = invoicePlan20d.minus(invoiceFinishAmount).toFixed(4);
                } else if (!invoicePlan10d.isZero()) {
                    row.invoiceInTransitGap = invoicePlan10d.minus(invoiceFinishAmount).toFixed(4);
                } else {
                    row.invoiceInTransitGap = null;
                }
                // 2. invoiceInTransitGapDiff开票计划预计偏差（万元）
                // 开票预计完成20日不为空，等于 开票计划 - 开票预计完成20日
                // 否则等于 开票计划 - 开票预计完成10日
                if (!invoicePlan20d.isZero()) {
                    row.invoicePlanExpectedDeviation = invoicePlanAmount.minus(invoicePlan20d).toFixed(4);
                } else if (!invoicePlan10d.isZero()) {
                    row.invoicePlanExpectedDeviation = invoicePlanAmount.minus(invoicePlan10d).toFixed(4);
                } else {
                    row.invoicePlanExpectedDeviation = null;
                }

                // 3. rebillInTransitGap回款在途缺口（万元）
                // 回款预计完成20日不为空，等于 回款预计完成20日 - 回款计划
                // 否则等于 回款预计完成10日 - 回款计划
                if (!rebillPlan20d.isZero()) {
                    row.rebillInTransitGap = rebillPlan20d.minus(rebillFinishAmount).toFixed(4);
                } else if (!rebillPlan10d.isZero()) {
                    row.rebillInTransitGap = rebillPlan10d.minus(rebillFinishAmount).toFixed(4);
                } else {
                    row.rebillInTransitGap = null;
                }

                // 4. rebillPlanExpectedDeviation回款计划预计偏差（万元）
                // 回款预计完成20日不为空，等于  回款计划 - 回款预计完成20日
                // 否则等于  回款计划 - 回款预计完成10日
                if (!rebillPlan20d.isZero()) {
                    row.rebillPlanExpectedDeviation = rebillPlanAmount.minus(rebillPlan20d).toFixed(4);
                } else if (!rebillPlan10d.isZero()) {
                    row.rebillPlanExpectedDeviation = rebillPlanAmount.minus(rebillPlan10d).toFixed(4);
                } else {
                    row.rebillPlanExpectedDeviation = null;
                }
            } catch (error) {
                // console.error('计算回款开票字段时出错:', error);
            }
        };

        const handleChangeRow = ({ prop, val, type, row, index }) => {
            // 当相关字段发生变化时，重新计算
            if (['invoicePlan20d', 'invoicePlan10d', 'rebillPlan20d', 'rebillPlan10d', 'invoiceFinishAmount', 'rebillPlanAmount'].includes(prop)) {
                row[prop] = _.cloneDeep(val?.toFixed(6));
                row[prop + 'key'] = val;
                calcRepaymentAndTicketFields(row);
            }
        };

        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });
        const exportLoading = ref(false);
        const handleExport = async(submit) => {
            const selectedRows = _.cloneDeep(repaymentList.selectedRows.value);
            const { value } = repaymentList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...newData,
                excelTitleList,
                idList: getCustomerIdList(selectedRows)
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            exportLoading.value = true;
            getCustomerExprot(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { exportLoading.value = false; });
        };

        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };
        // 需要汇总的列配置，key为列名(prop)，value为汇总值
        const downTemplateLoading = ref(false);
        const handleDownTemplate = async (submit, type) => {
            const { value } = repaymentList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const selectedRows = _.cloneDeep(repaymentList.selectedRows.value);
            const params = {
                ...newData
            };
            if (selectedRows.length) {
                params.idList = getCustomerIdList(selectedRows);
            }

            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            downTemplateLoading.value = true;
            invoiceTemplateDownloadApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { downTemplateLoading.value = false; });
        };

        const getSummaries = ({ columns, data }) => {
            return [
                columns.map((column, _columnsIndex) => {
                    if (_columnsIndex === 0) {
                        return '汇总';
                    }
                    const property = column.field;

                    // 只对指定的列进行汇总，直接从配置中获取汇总值
                    if (summaryColumns.value?.hasOwnProperty(property)) {
                        return summaryColumns.value[property];
                    }
                    return null;
                })
            ];
        };
        const openImport = async () => {
            // await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = repaymentList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const params = {
                ...newData
            };
            const selectedRows = _.cloneDeep(repaymentList.selectedRows.value);
            if (selectedRows.length) {
                params.idList = getCustomerIdList(selectedRows);
            }
            config.importConfig.downParams = params;
            setupContext.refs.fileDialogRef.openImport();
        };

        const setTableEditHandle = (val) => {
            const isTenTh = isCurrentTimeAfterOrEqualMonth16th(val.periodMonthConvert, dictDatas.value.CUSTOMER_INVOICE_OPEN_PERIOD['10DAY']);
            const isTwenty = isCurrentTimeAfterOrEqualMonth22th(val.periodMonthConvert, dictDatas.value.CUSTOMER_INVOICE_OPEN_PERIOD['20DAY']);
            const preLock = val.lockFlag?.toString() === '0';
            return {
                isTenTh: !isTenTh,
                isTwenty: !isTwenty,
                preLock,
                allStatus: (!isTenTh || !isTwenty) ? true : preLock
            };
        };
        // const EDIT_TYPE = { EDIT: 2, CANCEL: -3 };
        const editStatus = ref(false);
        const editHandle = () => {
            if (lockLoading.value.lock1 || lockLoading.value.lock0) return;
            // 保存编辑前的原始数据用于后续校验
            repaymentList.tableLoading.value = true;
            repaymentList.originalData.value = _.cloneDeep(repaymentList.totalData.value);
            setupContext.root.$nextTick(() => {
                const timer = setTimeout(() => {
                    repaymentList.tableLoading.value = false;
                    editStatus.value = true;
                    clearTimeout(timer);
                }, MAGIC_NUMBER.ONE_THOUSAND);
            });
        };
        const canelAction = (row) => {
            repaymentList.tableLoading.value = true;
            setupContext.root.$nextTick(() => {
                const timer = setTimeout(() => {
                    // 取消编辑，重置表格数据到未编辑前
                    repaymentList.totalData.value = _.cloneDeep(repaymentList.originalData.value);
                    repaymentList.tableLoading.value = false;
                    editStatus.value = false;
                    clearTimeout(timer);
                }, MAGIC_NUMBER.ONE_THOUSAND);
            });
        };
        const summaryColumns = ref({});
        const getCustomerSumHandle = (params) => {
            return getCustomerSum(params).then(res => {
                if (res && +res.code === 0) {
                    summaryColumns.value = res.data;
                }
            });
        };
        const tenUpdateField = ['invoicePlan10d', 'rebillPlan10d', 'invoiceErrorType', 'invoiceRemark', 'rebillErrorType', 'rebillRemark'];
        const twentyUpdateField = ['invoicePlan20d', 'rebillPlan20d', 'rebillErrorType', 'rebillRemark', 'invoiceErrorType', 'invoiceRemark'];
        const saveLoading = ref(false);
        const saveHandle = () => {
            const _totalData = _.cloneDeep(repaymentList.totalData.value);

            // 校验逻辑：如果原始数据中的开票10日、开票20日、回款10日、回款20日不为空，保存时也不能为空
            const validateFields = ['invoicePlan10d', 'invoicePlan20d', 'rebillPlan10d', 'rebillPlan20d'];
            const fieldLabels = {
                invoicePlan10d: '开票预计完成10日（万元）',
                invoicePlan20d: '开票预计完成20日（万元）',
                rebillPlan10d: '回款预计完成10日（万元）',
                rebillPlan20d: '回款预计完成20日（万元）'
            };

            const validationErrors = [];

            _totalData.forEach((row, index) => {
                const isTenTh = isCurrentTimeAfterOrEqualMonth16th(row.periodMonthConvert, dictDatas.value.CUSTOMER_INVOICE_OPEN_PERIOD['10DAY']);
                const isTwenty = isCurrentTimeAfterOrEqualMonth22th(row.periodMonthConvert, dictDatas.value.CUSTOMER_INVOICE_OPEN_PERIOD['20DAY']);
                // 只校验未锁定且在时间允许范围内的数据
                // setTableEditHandle(it).allStatus ? EDIT_TYPE.EDIT : EDIT_TYPE.CANCEL;
                if (!setTableEditHandle(row).allStatus) return;

                // eslint-disable-next-line complexity
                validateFields.forEach(field => {
                    // 根据时间判断哪些字段需要校验
                    // 如果当前时间>=16号，开票10日字段已经不能编辑了，也不需要校验
                    if (field === 'invoicePlan10d' && isTenTh) return;
                    // 如果当前时间>=22号，回款10日字段已经不能编辑了，但回款20日可以编辑
                    if (field === 'rebillPlan10d' && isTwenty) return;

                    // 获取原始数据中的值（从编辑状态前的数据中获取）
                    const originalRow = repaymentList.originalData?.value?.find(orig => orig.id === row.id);
                    const originalValue = originalRow ? originalRow[field] : null;
                    const currentValue = row[field];

                    // 如果原始数据不为空（非null、非undefined、非空字符串、非0），且当前值为空
                    if ((originalValue !== null && originalValue !== undefined && originalValue !== '' && originalValue !== 0)
                        && (currentValue === null || currentValue === undefined || currentValue === '' || currentValue === 0)) {
                        validationErrors.push(`第${index + 1}行${fieldLabels[field]}不能为空`);
                    }
                });
            });

            if (validationErrors.length > 0) {
                return Message.warning({
                    message: validationErrors.join('<br />'),
                    dangerouslyUseHTMLString: true
                });
            }
            // 过滤掉不需要编辑的字段
            const params = _totalData.filter(it => setTableEditHandle(it).allStatus).map(it => {
                const currentStatus = setTableEditHandle(it);
                let fields = ['id'];
                // 判断解锁全部字段可保存
                if (currentStatus.preLock) {
                    fields = [...fields, ...tenUpdateField, ...twentyUpdateField];
                } else {
                    // 判断锁定状态下 16 和22天限制
                    fields = [...fields, ...(currentStatus.isTenTh ? tenUpdateField : []), ...(currentStatus.isTwenty ? twentyUpdateField : [])];
                }
                return { ..._.pick(it, fields) };
            });
            if (!params.length) {
                return Message.warning('当前无可修改的数据!');
            }
            saveLoading.value = true;
            updateInvoice(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    repaymentList.getList();
                    editStatus.value = false;
                }
            }).finally(() => { saveLoading.value = false; });
        };
        // 解锁 1:上锁
        const lockFlagMenu = {
            '0': '解锁',
            '1': '锁定'
        };
        const lockLoading = ref({
            lock0: false,
            lock1: false
        });
        const lockHandle = async (lockFlag) => {
            MessageBox.confirm(`是否进行${lockFlagMenu[lockFlag]}?`, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                showCancelButton: false
            }).then(async () => {
                const selectedRows = _.cloneDeep(repaymentList.selectedRows.value);
                const { value } = repaymentList.searchModel;
                const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
                const params = {
                    ...newData,
                    lockFlagUpdate: lockFlag
                };
                lockLoading.value['lock' + lockFlag] = true;
                if (selectedRows.length) {
                    params.idList = getCustomerIdList(selectedRows);
                }
                lockInvoiceCustomer(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success(lockFlagMenu[lockFlag] + '成功');
                        repaymentList.getList();
                        repaymentList.selectedRows.value = []; // 请求列表后清空勾选数据
                    }
                }).finally(() => {
                    lockLoading.value['lock' + lockFlag] = false;
                });
            });
        };
        const uploadSuccessHandle = () => {
            repaymentList.getList();
        };
        const searchChange = ({ column, searchData }) => {
            repaymentList.selectedRows.value = []; // 请求列表后清空勾选数据
            setupContext.refs.searchBox.submitSearch();
        };
        const allowRowClickFunc = (row) => {
            return repaymentList.selectedRows.value.some(it => it.id !== row.id);
        };
        const rowClickEditFunc = (row, records) => {
            if (!editStatus.value) {
                return false;
            }
            return !!records.some(it => it.id === row.id);
        };
        const dictDatas = ref({});
        onMounted(async() => {
            dictDatas.value = await otherUtils.getDictDataList(config.columns, ['CUSTOMER_INVOICE_OPEN_PERIOD']);
            await getIndustryTreeList();
            config.searchFields.forEach(it => {
                if (it.value === 'industryCategoriesCode') {
                    it.options = industryData.value;
                }
            });
            setupContext.refs.searchBox.submitSearch();
        });
        return {
            repaymentList,
            config,
            utils,
            authorityCode,
            editStatus,
            downTemplateLoading,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            lockLoading,
            isShowMoreBtn,
            exportLoading,
            saveLoading,
            rowClickEditFunc,
            allowRowClickFunc,
            searchChange,
            uploadSuccessHandle,
            handleDownTemplate,
            handleChangeRow,
            handleExport,
            getSummaries,
            openImport,
            canelAction,
            editHandle,
            lockHandle,
            saveHandle,
            setTableEditHandle
        };
    }
};
</script>
<style lang="less">
.repayment-manage {
    width: 100%;
    .repayment-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .el-tabs {
        width: 100%;
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.repayment-manage-paper {
        padding: 0px 0px 0px;
    }
    .col-append-box {
        display: flex;
        align-items: center;
        .col-append-btn {
            padding-bottom: 3px;
            padding-left: 3px;
            .eye-btn {
                display: inline-block;
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
    }
    input[type=number] {
        -moz-appearance: textfield;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

}
.repayment-list-dropdown.el-dropdown {
        color: #fff;
        vertical-align: middle;

        .el-button--mini {
            padding: 7px 15px;
        }
    }
    .repayment-list-dropdown-menu {
        background: #fff!important;
        padding: 0;
        white-space: nowrap;

        .dropdown-item {
            color: #333;
            font-size: 14px;
            padding: 8px 20px;
            line-height: 1.5;
            cursor: pointer;
            transition: background 0.2s, color 0.2s;
            text-align: center;
            justify-content: center;
            display: flex;
            color: #4285f5;
            background: #fff;
        }

        .dropdown-item:hover {
            background: #f5f7fa;
            color: #4285f5;
        }
    }
</style>
